<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="annualchanges">3. Annual Changes</h2>
          <p>Use this map to see the hotspots where your landscape has changed the most in one year.</p>

          <p>To see the hotspots for a specific year, click on the data in the column for that year. For each dataset only the top 25 hotspots larger than 1 hectare appear on the map. The table under the map shows the total area of alerts, including those smaller than 1 hectare. </p>

          <p>Click a hotspot on the map to compare satellite images from before and after the change. Try selecting different time periods to get the best view of how the area has changed. </p>

        <AlertMap 
          title="Annual Changes" 
          numSlots="9" 
          slotType="yearly" 
          sources="cafi_burned_area_hotspots,mapbiomas_deforestation_hotspots,prodes_deforestation_hotspots,images_disturbance_hotspots,hansen_forest_loss_hotspots,jrc_tmf_deforestation_hotspots,jrc_tmf_degradation_hotspots,ciat_terra_i,cafi_deforestation_hotspots,cafi_degradation_hotspots" 
          attribution="Maps: Geofolio Landscape Reports. Data: GFW [4]/JRC [5]/CIAT-Terra-i [15]/Planet [7]. Backgrounds: Mapbox/Openstreetmap Contributors [13]/Planet NICFI composites/ESA WorldCover." 
          v-bind:location="location" 
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded" 
           >
        </AlertMap>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import AlertMap from '@/components/factsheet/ldr/maps/AlertMap.vue'
    
    export default {
        name: 'Hotspots',
        components: { AlertMap },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
              
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>